import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

// Fetch Tasks
export const useFetchTasks = (filters) => {
  const fetchTasks = async () => {
    const { data } = await instance.get(`/api/shopper/tasks`); // Your API endpoint
    // const { data } = await instance.get(`/api/shopper/tasks?pageNumber=1&pageSize=1000&search&orgId=${filters.orgId}`); // Your API endpoint
    return data;
  };

  const query = useQuery({
    queryKey: ['fetch Tasks'],
    queryFn: fetchTasks,
  });

  return query;
};

// Add Project
export const useAddProject = () => {
  const queryClient = useQueryClient();
  const addProjectMutation = useMutation(async (newProject) => {
    const { data } = await instance.post('/api/Tasks', newProject); // Your API endpoint
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch Tasks']);
    },
  });

  return addProjectMutation;
};

// Update Project
export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  const updateProjectMutation = useMutation(async (updatedProject) => {
    const { data } = await instance.put(`/api/Tasks/${updatedProject.id}`, updatedProject); // Include ID
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch Tasks']);
    },
  });

  return updateProjectMutation;
};

// Delete Project
export const useDeleteProject = () => {
  const queryClient = useQueryClient();
  const deleteProjectMutation = useMutation(async (projectId) => {
    await instance.delete(`/api/Tasks/${projectId}`); // Include ID
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch Tasks']);
    },
  });

  return deleteProjectMutation;
};
